import React, { useState, useEffect, useMemo } from "react";
import editIcon from "../assets/edit.png";
import viewIcon from "../assets/View.svg";
import downloadIcon from "../assets/Download.svg";
import leftArrow from "../assets/left-arrow.png";
import rightArrow from "../assets/right-arrow.png";
import downArrow from "../assets/down-arrow.png";
import rightChevron from "../assets/right-chevron.png";
import leftChevron from "../assets/left-chevron.png";
import { getEmployeeDetails } from "../api/employeesApi";
import { getPaystubs } from "../api/paystubsApi";
import { getDocuments } from "../api/documentApi";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const paystubs = [
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
];

const documents = [
  {
    label: "Federal W-4",
    jurisdiction: "FED",
    category: "Employee Tax Document",
    year: 2024,
    filedOn: "Feb 16, 2024",
  },
  {
    label: "Federal W-4",
    jurisdiction: "FED",
    category: "Employee Tax Document",
    year: 2025,
    filedOn: "Mar 21, 2025",
  },
];

const Dashboard = () => {
  const [employee, setEmployee] = useState(null);
  const [paystubs, setPaystubs] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const totalPages = Math.ceil(paystubs.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const navigate = useNavigate();

  const currentPaystubs = useMemo(() => {
    console.log("=======chat", isLoading);

    return paystubs?.results?.slice(startIndex, startIndex + rowsPerPage);
  }, [paystubs]);
  // const currentData = paystubs.slice(startIndex, startIndex + rowsPerPage);
  const companyId = "com_affa65d93030f0118b3d6045bdc7c627";
  const employeeId = "emp_55b194e8f530f0118b3d6045bdc7c627";

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const [empRes, stubRes, docRes] = await Promise.all([
          getEmployeeDetails(companyId, employeeId),
          getPaystubs(companyId, employeeId),
          getDocuments(companyId),
        ]);
        setEmployee(empRes?.data || []);
        setPaystubs(stubRes?.data?.results || []);
        setDocuments(docRes?.data || []);
      } catch (err) {
        console.error("Dashboard load error:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handleRowsChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const handleEditClick = () => {
    navigate("/manage-employee/edit-employee");
  };

  return (
    <div className="p-4">
      <h4 className="mb-2 main-title-for-all">Dashboard</h4>
      <p className="gray-text-for-content mb-4">
        Access your payroll information, manage benefits, and stay connected -
        all in one place.
      </p>

      <div className="mb-4 p-4 bg-white rounded">
        <h5 className="sub-title">
          Employee Id :
          <span
            className="ms-4 gray-text-for-content"
            style={{
              fontWeight: "400",
              background: "#F8F8F8",
              borderRadius: "20px",
              padding: "7px 20px",
            }}
          >
            {employee?.id}
            <img
              src={editIcon}
              style={{ width: "14px", margin: "-4px 0px 0px 12px" }}
              alt="edit"
              onClick={handleEditClick}
            />
          </span>
        </h5>
        <div
          className="d-flex align-items-center justify-content-between flex-wrap  "
          style={{
            border: "1px solid #C4C4C480",
            borderRadius: "10px",
            padding: "30px 20px",
            marginTop: "22px",
          }}
        >
          <div>
            <p className="gray-text-for-content mb-2">Onboard Status</p>
            <button className="yellow-button">
              {employee?.onboard?.status || "Pending"}
            </button>
          </div>
          <div>
            <p className="gray-text-for-content mb-2">Active Status</p>
            <button className="green-button">
              {employee?.active ? "Active" : "Inactive"}
            </button>
          </div>
          <div>
            <button className="lite-orange-button">View Profile</button>
          </div>
        </div>
      </div>

      <div className="mb-4 bg-white p-4 rounded">
        <h5 className="mb-3 sub-title">Paystubs</h5>
        <div className="table-responsive table-border-layout">
          <table style={{ width: "100%" }}>
            <thead>
              <tr className="table-head">
                <th>Payday</th>
                <th>Period</th>
                <th>Net Pay</th>
                <th>Gross Pay</th>
                <th>Reimbursements</th>
                <th>Employee Taxes</th>
                <th>Action</th>
              </tr>
            </thead>
            {isLoading ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "320%",
                  marginTop: "20%",
                }}
              >
                <Spinner animation="border" />
              </div>
            ) : (
              <tbody className="gray-text-for-content">
                {currentPaystubs?.length > 0 &&
                  currentPaystubs?.map((stub, idx) => (
                    <tr key={idx}>
                      <td>{formatDate(stub.payday)}</td>
                      <td>
                        {formatDate(stub.periodStart)} -{" "}
                        {formatDate(stub.periodEnd)}
                      </td>
                      <td>${stub.netPay?.toFixed(2)}</td>
                      <td>${stub.grossPay?.toFixed(2)}</td>
                      <td>${stub.reimbursements?.toFixed(2)}</td>
                      <td>${stub.employeeTaxes?.toFixed(2)}</td>
                      <td>
                        <button className="border-0 p-0 mx-1">
                          <img src={viewIcon} alt="view" />
                        </button>
                        <button className="border-0 p-0 mx-1">
                          <img src={downloadIcon} alt="download" />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
          </table>
        </div>

        <div className="d-flex justify-content-end align-items-center mt-4">
          <div className="d-flex align-items-center">
            <span className="me-2 gray-text-for-content">Rows per page:</span>
            <select
              className="form-select gray-text-for-content border-0"
              style={{ width: "70px" }}
              value={rowsPerPage}
              onChange={handleRowsChange}
            >
              {[5, 10, 15, 20].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex align-items-center ">
            <span className="me-3 gray-text-for-content">
              {currentPage} - {totalPages === 0 ? 1 : totalPages}
            </span>

            <button
              className="me-2 border-0"
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              <img src={leftChevron} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handlePrev}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === 1}
            >
              <img src={leftArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handleNext}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0"
              onClick={() => setCurrentPage(totalPages)}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightChevron} style={{ width: "14px" }} alt="" />
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded">
        <h5 className="mb-3 sub-title">Documents</h5>
        <div className="table-responsive table-border-layout">
          <table style={{ width: "100%" }}>
            <thead>
              <tr className="table-head">
                <th>Label</th>
                <th>Jurisdiction</th>
                <th>Category</th>
                <th>Year</th>
                <th>Filed On</th>
                <th>Action</th>
              </tr>
            </thead>
            {isLoading ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "320%",
                  marginTop: "20%",
                }}
              >
                <Spinner animation="border" />
              </div>
            ) : (
              <tbody className="gray-text-for-content">
                {documents?.length > 0 &&
                  documents.map((doc, idx) => (
                    <tr key={idx}>
                      <td>{doc.label}</td>
                      <td>{doc.jurisdiction}</td>
                      <td>{doc.category}</td>
                      <td>{doc.year}</td>
                      <td>{formatDate(doc.filedOn)}</td>
                      <td>
                        <button className="border-0 p-0 mx-1">
                          <img src={downloadIcon} alt="download" />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
          </table>
        </div>
        <div className="d-flex justify-content-end align-items-center mt-4">
          <div className="d-flex align-items-center">
            <span className="me-2 gray-text-for-content">Rows per page:</span>
            <select
              className="form-select gray-text-for-content border-0"
              style={{ width: "70px" }}
              value={rowsPerPage}
              onChange={handleRowsChange}
            >
              {[5, 10, 15, 20].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex align-items-center ">
            <span className="me-3 gray-text-for-content">
              {currentPage} - {totalPages === 0 ? 1 : totalPages}
            </span>

            <button
              className="me-2 border-0"
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              <img src={leftChevron} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handlePrev}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === 1}
            >
              <img src={leftArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handleNext}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0"
              onClick={() => setCurrentPage(totalPages)}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightChevron} style={{ width: "14px" }} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
